import React from 'react';

const MapSection = () => {
  return (
    < >
      <iframe
        title="Google Maps"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17406.863213911947!2d77.08235240370036!3d28.481229757514498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1923866aaaab%3A0x48c36c2d8b05e35f!2sJMD%20Regent%20Square!5e1!3m2!1sen!2sin!4v1737353480146!5m2!1sen!2sin"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      
    </>
  );
};

      
export default MapSection;
